import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import GoogleMapReact from 'google-map-react'
import { IoMdPin } from 'react-icons/io'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import iconEmergencia from '../icons/icon-emergencia.svg'
import iconUrgencia from '../icons/icon-urgencia.svg'
import iconPrioridadeI from '../icons/icon-prioridade-i.svg'
import iconPrioridadeII from '../icons/icon-prioridade-ii.svg'
import iconVitalidade from '../icons/icon-vitalidade.svg'
import iconRelatorio from '../icons/icon-relatorio.svg'
import iconBaixo from '../icons/icon-baixo.svg'
import iconModerado from '../icons/icon-moderado.svg'
import iconAlto from '../icons/icon-alto.svg'
import iconSun from '../icons/icon-sun.svg'
import iconSunrise from '../icons/icon-sunrise.svg'
import iconSunset from '../icons/icon-sunset.svg'
import iconMoonBegin from '../icons/icon-moon-begin.svg'
import iconNigthPass from '../icons/icon-night-pass.svg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import imgcentralate from '../icons/centralate.svg'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .image.gatsby-image-wrapper {
    width: 100%;
  }
  .col1 {
    padding-right: 80px;
    width: 100%;
    @media ${device.mobileL} {
      padding-right: 0;
      width: 100%;
    }
  }
  .eye {
    padding: 3em 2em;
    position: relative;
    background: ${colors.verdeGradiente};
    color: #ffffff;
    .center {
      padding: 0;
    }

    .columns {
      .col1 {
        padding-right: 0;
      }
      img {
        width: 52%;
        margin-top: 10px;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /**
      Target IE11
      */
          width: auto;
        }
      }
    }
    .inner {
      display: block;
      border-bottom: 6px #ffffff solid;
      border-left: 6px #ffffff solid;
      border-right: 6px #ffffff solid;
      padding: 1em 2em;
      margin: 0;
      position: relative;
      @media ${device.mobileL} {
        padding: 1em 1.6em;
      }

      .columns {
        display: flex;
        justify-content: space-between;
        img.image {
          margin-left: 20px;
          height: 100%;
          @media ${device.mobileL} {
            margin-left: 0px;
            margin-top: 20px;
            width: 100%;
          }
        }
        @media ${device.mobileL} {
          flex-wrap: wrap;
        }
      }
      :before {
        content: '';
        background: #ffffff;
        width: 2%;
        height: 6px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
      }
    }
    h1 {
      font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
      font-size: 2em;
      color: #ffffff;
      line-height: 1em;
      margin-top: -52px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      div.title {
        max-width: 635px;
        @media ${device.mobileL} {
          max-width: 204px;
          font-size: 1em;
          line-height: 1.2em;
          margin-top: -50px;
        }
      }
      :after {
        content: '';
        background: #ffffff;
        height: 6px;
        flex-grow: 1;
        margin: 32px -40px 0px 10px;
        @media ${device.mobileL} {
          margin: -21px -37px 0px 10px;
        }
      }
      @media ${device.mobileL} {
        position: static;
        text-align: left;
        padding: 0;
        margin-top: 0px;
      }
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  h2 {
    color: #8e8fc7;
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }
  p {
    font-size: 0.8em;
  }
  .inner {
    display: flex;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    img {
      @media ${device.mobileL} {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
  .atendimento {
    display: flex;
    justify-content: space-between;
    margin: 3em 0;
    @media ${device.mobileL} {
      flex-wrap: wrap;
      margin: 2em -20px;
    }
    img.image {
      width: 50px;
      display: block;
    }
    .info {
      width: 25%;
      background: #ffffff;
      justify-content: center;
      margin: 0 20px 0 0;
      box-sizing: border-box;
      box-shadow: 1px 1px 10px #516d6e;
      :last-child {
        margin: 0;
        @media ${device.mobileL} {
          margin: 0 0 15px 0;
        }
      }
      div {
        height: 50%;
        min-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;

        @media ${device.mobileL} {
          height: 70px;
        }
      }
      p {
        text-align: center;
        text-transform: uppercase;
        margin: 0;

        @media ${device.mobileL} {
          font-size: 0.7em !important;
        }
      }
      @media ${device.mobileL} {
        width: 48%;
        margin: 0 0 15px 0;
        img {
          width: 30%;
        }
      }
      :nth-child(1) {
        .icone {
          background-color: #bb0600;
        }
        p {
          color: #bb0600;
        }
      }
      :nth-child(2) {
        .icone {
          background-color: #d63d00;
        }
        p {
          color: #d63d00;
        }
      }
      :nth-child(3) {
        .icone {
          background-color: #fc8800;
        }
        p {
          color: #fc8800;
        }
      }
      :nth-child(4) {
        .icone {
          background-color: #186d27;
        }
        p {
          color: #186d27;
        }
      }
      :nth-child(5) {
        .icone {
          background-color: #882f60;
        }
        p {
          color: #882f60;
        }
      }
      :nth-child(6) {
        .icone {
          background-color: #144a67;
        }
        p {
          color: #144a67;
        }
      }
    }
  }
  .quadros {
    display: flex;
    background-color: #ffffff;
    margin-bottom: 15px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
    .movimentos {
      display: flex;
      padding: 1em 0;
      align-items: center;
      @media ${device.mobileL} {
        padding: 1em;
      }
      p {
        margin: 0;
        padding: 0 30px;
      }
      img {
        padding: 0 24px;
        border-right: solid 1px #707070;
        box-sizing: border-box;
      }
    }
    .horarios {
      display: flex;
      padding: 1em 0;
      min-width: 280px;
      align-items: center;
      p {
        margin: 0;
        color: #ffffff;
      }
      img {
        padding: 0 2em;
        @media ${device.mobileL} {
          padding-left: 0;
        }
      }
      @media ${device.mobileL} {
        justify-content: center;
      }
    }
    :nth-of-type(1) {
      .horarios {
        background-color: #93d4e5;
      }
    }
    :nth-of-type(2) {
      .horarios {
        background-color: #43c1e2;
      }
    }
    :nth-of-type(3) {
      .horarios {
        background-color: #dd7f44;
      }
    }
    :nth-of-type(4) {
      .horarios {
        background-color: #61639a;
      }
    }
    :nth-of-type(5) {
      .horarios {
        background-color: #a6a8d8;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  .pronto {
    color: #8e8fc7;
    padding-top: 2em;
  }
  .agendamento {
    p {
      display: inline;
      color: #ffffff;
      font-size: 0.8em;
      margin-left: 63px;
      @media ${device.mobileL} {
        margin-left: 0;
      }
    }

    .central {
      display: flex;
      align-items: flex-start;
      div {
        width: 100%;
        padding: 20px 0;
        @media ${device.mobileL} {
          display: block;
        }
      }
      a {
        margin-left: 63px;
        color: #ffffff;
      }
      .tel {
        display: flex;
        text-justify: top;
        padding: 0;
        h3 {
          color: #f4edc6;
          margin: 0 20px;
          @media ${device.mobileL} {
            display: block;
          }
        }
      }
      .map {
        width: 100%;
        height: 300px;
        border: 1px solid #148581;
        padding: 0;
        @media ${device.mobileL} {
          position: static;
          margin-bottom: 1em;
          width: 100%;
          height: 200px;
        }
      }
      @media ${device.mobileL} {
        display: block;
      }
    }
  }
  :nth-of-type(2) {
    @media ${device.mobileL} {
      padding-top: 0;
    }
  }
  :nth-of-type(5) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
    h2 {
      color: #ffffff;
    }
  }
`
const Map = ({ text }) => (
  <div>
    <IoMdPin size="2em" color="red" />
  </div>
)

export const ProntoAtendimentoTemplate = ({
  title,
  content,
  image,
  imageMobile,
  slug,
  color,
  area = 'Para Mulheres',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          imageMobile={imageMobile}
          color={color}
          txtColor="verde"
          height="209px"
          bottom="-70px"
          imgWidth="51.2%"
          right="-1px"
          titleWidth="438px"
          overflow="visible"
          imgInner
          mobileTop="-13.5%"
          mobileRight="0%"
        />
        <GroupContent>
          <div className="center inner">
            <div className="col1">
              <h2>{parse(sessoes[0].tituloDaSessao)}</h2>
              {parse(sessoes[0].texto)}
            </div>
            {sessoes[0].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[0].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Caso a caso"
                className="image"
              />
            ) : (
              <img
                src={sessoes[0].imagemDaSessao.sourceUrl}
                alt="Caso a caso"
                className="image"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent className="eye">
          <div className="center">
            <div className="inner">
              <h1>
                <div className="title">{parse(sessoes[1].tituloDaSessao)}</div>
              </h1>
              {parse(sessoes[1].texto)}
              <div className="atendimento">
                <div className="info">
                  <div className="icone">
                    <img src={iconEmergencia} alt="Emergencia" />
                  </div>
                  <div>
                    <p>emergência</p>
                  </div>
                </div>
                <div className="info">
                  <div className="icone">
                    <img src={iconUrgencia} alt="Urgência" />
                  </div>
                  <div>
                    <p>urgência</p>
                  </div>
                </div>
                <div className="info">
                  <div className="icone">
                    <img src={iconPrioridadeI} alt="Prioridade I" />
                  </div>
                  <div>
                    <p>prioridade i</p>
                  </div>
                </div>
                <div className="info">
                  <div className="icone">
                    <img src={iconPrioridadeII} alt="Prioridade II" />
                  </div>
                  <div>
                    <p>prioridade ii</p>
                  </div>
                </div>
                <div className="info">
                  <div className="icone">
                    <img src={iconVitalidade} alt="Vitalidade" />
                  </div>
                  <div>
                    <p>vitalidade fetal</p>
                  </div>
                </div>
                <div className="info">
                  <div className="icone">
                    <img src={iconRelatorio} alt="Relatório" />
                  </div>
                  <div>
                    <p>relatório de internação</p>
                  </div>
                </div>
              </div>
              <div className="columns">
                <div className="col1">{parse(sessoes[2].texto)}</div>
                {sessoes[2].imagemDaSessao.localFile ? (
                  <Img
                    fluid={
                      sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                    }
                    alt="Doppler"
                    className="image"
                  />
                ) : (
                  <img
                    src={sessoes[2].imagemDaSessao.sourceUrl}
                    alt="Doppler"
                    className="image"
                  />
                )}
              </div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[3].tituloDaSessao)}</h2>
            {parse(sessoes[3].texto)}
            {parse(sessoes[4].texto)}
            <div className="quadros">
              <div className="horarios">
                <img src={iconSunrise} alt="Manhã" />
                <p>
                  <strong>{parse(sessoes[5].tituloDaSessao)}</strong>
                </p>
              </div>
              <div className="movimentos">
                <img src={iconBaixo} alt="Icone Baixo" />
                {parse(sessoes[5].texto)}
              </div>
            </div>
            <div className="quadros">
              <div className="horarios">
                <img src={iconSun} alt="Tarde" />
                <p>
                  <strong>{parse(sessoes[6].tituloDaSessao)}</strong>
                </p>
              </div>
              <div className="movimentos">
                <img src={iconAlto} alt="Icone Alto" />
                {parse(sessoes[6].texto)}
              </div>
            </div>
            <div className="quadros">
              <div className="horarios">
                <img src={iconSunset} alt="Inicio da noite" />
                <p>
                  <strong>{parse(sessoes[7].tituloDaSessao)}</strong>
                </p>
              </div>
              <div className="movimentos">
                <img src={iconModerado} alt="Icone Moderado" />
                {parse(sessoes[7].texto)}
              </div>
            </div>
            <div className="quadros">
              <div className="horarios">
                <img src={iconMoonBegin} alt="Noite" />
                <p>
                  <strong>{parse(sessoes[8].tituloDaSessao)}</strong>
                </p>
              </div>
              <div className="movimentos">
                <img src={iconAlto} alt="Icone Alto" />
                {parse(sessoes[8].texto)}
              </div>
            </div>
            <div className="quadros">
              <div className="horarios">
                <img src={iconNigthPass} alt="Madrugada" />
                <p>
                  <strong>{parse(sessoes[9].tituloDaSessao)}</strong>
                </p>
              </div>
              <div className="movimentos">
                <img src={iconModerado} alt="Icone Moderado" />
                {parse(sessoes[9].texto)}
              </div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <div className="agendamento">
              <div className="central">
                <div>
                  <div className="tel">
                    <img src={imgcentralate} alt="Telefone" />
                    <h3>Central de Atendimento</h3>
                  </div>
                  <div>
                    <a href="tel:(11)5080-6070"> (11) 5080-6070</a>
                  </div>
                  <div>
                    <p>Rua do Paraíso, 432 | Paraíso | CEP 04103-000</p>
                  </div>
                </div>
                <div>
                  <div className="map">
                    <GoogleMapReact
                      bootstrapURLKeys={{
                        key: 'AIzaSyCLOHkYMoPTOSfoQxhwpV4wXbo1EkYJvqI',
                      }}
                      yesIWantToUseGoogleMapApiInternals
                      defaultCenter={{ lat: -23.5743221, lng: -46.6388567 }}
                      defaultZoom={16}
                    >
                      <Map lat={-23.5743221} lng={-46.6388567} />
                    </GoogleMapReact>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

ProntoAtendimentoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const ProntoAtendimento = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const imageMobile = page.imagensMobile.imagemMobile
    ? page.imagensMobile.imagemMobile.sourceUrl
    : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <ProntoAtendimentoTemplate
        title={page.title}
        content={page.content}
        image={image}
        imageMobile={imageMobile}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

ProntoAtendimento.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ProntoAtendimento

export const ProntoAtendimentoQuery = graphql`
  query ProntoAtendimentoById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      imagensMobile {
        imagemMobile {
          sourceUrl
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
